/*
  周扬
  2023.06.15
  制作VPN申请页面
*/ 
<template>
  <div class="PartsVpn mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/VPN001"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <a download=""></a>
          <el-main>
            <div class="mainWrao" v-loading="fullscreenLoading">
              <div class="recordTitle">
                <h1>{{$t('VpnApply.title')}}</h1>
              </div>
              <!-- 页面主体部分-->
              <div class="my">
                <!-- 内容 -->
                <div class="tableWrap">
                    <!-- 搜索条件 -->
                    <div class="datePick">
                        <el-row>
                          <!-- 工厂名称关键字 -->
                          <label class="code-margin">{{$t('VpnApply.searchCompany')}}：</label>
                          <el-input
                            class="code-select-width"
                            :placeholder="$t('VpnApply.enterCompany')"
                            v-model="companyContent"
                            clearable>
                          </el-input>
                          <!-- 盒子名称关键字 -->
                          <label class="code-margin">{{$t('VpnApply.searchBox')}}：</label>
                          <el-input
                            class="code-select-width"
                            :placeholder="$t('VpnApply.enterBox')"
                            v-model="boxContent"
                            clearable>
                          </el-input>
                          <!-- 两个按钮 -->
                          <div class="btns">
                              <el-button size="small" @click="btn_clean()">{{$t('VpnApply.Clean')}}</el-button>
                              <el-button type="primary" size="small" icon="el-icon-search" @click="searchDataByButton()">{{$t('VpnApply.search')}}</el-button>
                          </div>
                        </el-row>
                    </div>

                    <!-- 表格 -->
                    <el-table
                      v-loading="loading"
                      :data="tableData"
                      style="width: 100%; text-align: center;"
                      :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')">
                      <!-- 公司名称 -->
                      <el-table-column
                          prop="machineEn"
                          :label="$t('VpnApply.company')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.factoryName}}</span>
                          </template>
                      </el-table-column>
                      <!-- 盒子名称 -->
                      <el-table-column
                          prop="msgEn"
                          :label="$t('VpnApply.box')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.boxName}}</span>
                          </template>
                      </el-table-column>
                      <!-- 盒子IP -->
                      <el-table-column
                          prop="msgEn"
                          :label="$t('VpnApply.boxIp')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.boxIp}}</span>
                          </template>
                      </el-table-column>
                      <!-- 创建时间 -->
                      <el-table-column
                          prop="typeEn"
                          :label="$t('VpnApply.createTime')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{formatDate(scope.row.createTime)}}</span>
                          </template>
                      </el-table-column>
                      <!-- 盒子状态 -->
                      <el-table-column
                          prop="descriptionEn"
                          :label="$t('VpnApply.status')"
                          max-width="200">
                           <template slot-scope="scope">
                            <span v-if="scope.row.boxApply.status===0">未申请</span>
                            <span v-else-if="scope.row.boxApply.status===1">审核中</span>
                            <span v-else-if="scope.row.boxApply.status===2" style="color: red">拒绝</span>
                            <span v-else-if="scope.row.boxApply.status===3" style="color: blue">通过</span>
                          </template>
                      </el-table-column>
                      <!-- 审核人 -->
                      <el-table-column
                          prop="actionDesEn"
                          :label="$t('VpnApply.reviewer')"
                          max-width="200">
                          <template slot-scope="scope">
                            <span>{{scope.row.reviewerName}}</span>
                          </template>
                      </el-table-column>
                      <!-- 操作按钮 -->
                      <el-table-column
                          prop="endStateDesEn"
                          :label="$t('VpnApply.operation')"
                          max-width="200">
                          <template slot-scope="scope">
                            <el-button
                              v-if="scope.row.boxApply.status===0"
                              size="mini"
                              type="primary"
                              style="width: 80px;"
                              @click="handleApply(scope.row.id)">申请</el-button>

                            <el-button
                              v-if="scope.row.boxApply.status===2"
                              size="mini"
                              type="warning"
                              style="width: 80px;"
                              @click="handleApplyAgain(scope.row.id)">重新申请</el-button>

                            <el-button
                              v-if="scope.row.boxApply.status===3"
                              size="mini"
                              type="success"
                              style="width: 80px;"
                              @click="handleDownload(scope.row.boxApply.applicantSign)">下载证书</el-button>
                          </template>
                      </el-table-column>
                    </el-table>

                </div>
                <!-- 分页 -->
                <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page.sync="nowPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleCurrentSizeChange">
                </el-pagination>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import { formatDate } from '../assets/js/date.js'

export default {
  name: 'VPN001',
  components: {
    leftNav
  },
  data () {
    return {
      // 全局加载控制
      fullscreenLoading: false,
      // 表格加载提示开关
      loading: false,
      // 当前页数
      nowPage: 1,
      // 每页条数
      nowPageSize: 10,
      // 总页数
      total: 1,
      // 模糊搜索-公司名称
      companyContent:'',
      // 模糊搜索-盒子名称
      boxContent:'',
      // 表格数据
      tableData: []
      
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    datevalue(){
      
    }
  },
  created(){
    this.searchData()
  },
  mounted() {
  
  },
  destroyed() {
  },
  methods: {
    // 页码变化
    handleCurrentChange (val) {
      this.nowPage = val
      this.searchData()
    },
    // 每页条数变化
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.searchData()
    },
    // 通过点击查询按钮查询数据
    searchDataByButton () {
      this.nowPage = 1
      this.searchData()
    },
    // 查询数据列表
    searchData () {
      this.loading = true
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/box/boxMsgToApplyList',
        params:{
          pageNum: _this.nowPage,
          pageSize: _this.nowPageSize,
          factoryName: _this.companyContent, //工厂名称关键字
          boxName: _this.boxContent, //盒子关键字
          userId: _this.$store.state.authCode
        }
      }).then(function(res){

        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.total = res.data.total//页码数
          _this.tableData = res.data.list
        }
        _this.loading = false
          
      }).catch(function () {
          _this.loading = false
      })
    },
    // 清除功能
    btn_clean () {
      // 当前页数
      this.nowPage =  1
      this.nowPageSize =  10

      // 输入查询的内容
      this.companyContent = '';
      this.boxContent=''

    },
    // 申请请求
    handleApply (id) {
      this.$confirm('您确定要申请VPN吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.sendApply(id);
      }).catch(() => {
        // 取消        
      });
    },
    // 在申请请求
    handleApplyAgain (id) {
      this.$confirm('您确定要继续申请VPN吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.sendApply(id);
      }).catch(() => {
        // 取消        
      });
    },
    // 下载请求
    handleDownload (sign) {
      this.axios({
        method: 'get', //这个不解释了吧
        url: '/download/box/downloadZip',           //路径
        params: {
          userSign: sign,
        },
        responseType: 'blob', //告诉服务器想到的响应格式
        headers: { 'Content-Type': 'application/json; application/octet-stream' },
      }).then(res => {
        let blob = new Blob([res.data], { type: 'application/zip' }); //设置下载的内容以及格式
        const url = window.URL.createObjectURL(blob); //设置路径
        const link = window.document.createElement('a'); // 创建a标签
        link.href = url;
        link.download = '文件'; //设置文件名
        link.style.display = 'none';
        link.click();
        URL.revokeObjectURL(url); // 释放内存
      }).catch(function (error) {
        showMessage('下载失败', 'error');
      });
    },
    // 发送申请请求
    sendApply (id) {
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/box/sendBoxApply',
        params:{
          boxId: id, //盒子id
          userId: _this.$store.state.authCode //用户id
        }
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.searchData()
        }
        _this.fullscreenLoading = false
        
      }).catch(function () {
        _this.fullscreenLoading = false
      })
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
.PartsVpn{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 35px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}

/* 我的样式 */
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}

.tableWrap{
  padding: 5px 30px;
}

.datePick{
  margin: 10px 0;
}
.datePick .btns{
  float: right;
}

.pagination{
  text-align: center;
  margin-top: 35px;
}

.type-select-width{
    width: 170px;
}
.code-select-width{
    width: 144px;
}
.code-margin{
    margin-left: 10px;
}

</style>

